import { render, staticRenderFns } from "./Bcel.vue?vue&type=template&id=310d739e&"
import script from "./Bcel.vue?vue&type=script&lang=js&"
export * from "./Bcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports